class SearchAutocomplete {
    constructor(selector = '.js-search-main') {
        this.selectors = {
            document,
            input: selector,
            body: 'body',
            form: '.js-search-form',
            clearInput: '.js-search-form .clear_input',
            rightPart: '.js-right-part',
            rightPartCat: '.js-right-part ul',
            overlay: '.overlay_for_menu',
            openSearchBtn: '#open-search-btn',
            searchClose: '.header_mobile #js-search-close',
            searchBox: '.header_mobile #js-search-box'
        };

        this.init();

        this.virtualDiv = $('<div/>')

    }   

    unescapeHtml( text ){
        if ( typeof DOMParser !== 'undefined' )
            return new DOMParser().parseFromString(text, "text/html").documentElement.textContent
        else
            return this.virtualDiv.html( text ).text()
    }

    init() {
        this.getNodes();
        this.typeahead();
        this.events();
    }

    getNodes() {
        var _this = this;

        this.nodes = {};

        $.each(this.selectors, function(key, selector) {
            _this.nodes[key] = $(selector);
        });
    }

    events(){
        this.nodes.openSearchBtn.on('click', () => {
            this.nodes.form.addClass('focused')
            this.nodes.input.focus().trigger('typeahead:open')
        })
		this.nodes.searchClose.on('click', e => {
			e.preventDefault();
			this.nodes.searchBox.removeClass('open');
		});

    }

    typeahead() {
        const self = this;

        self.nodes.clearInput.on( 'click', ( e ) => {
            self.nodes.input.blur().val( '' )
            self.nodes.form.removeClass( 'empty' )
            self.nodes.document.find('.tt-menu').addClass('tt-empty')
        } )

        const options = {
            minLength: 2,
            highlight: true,
            hint: false,
        };
        const lang = self.nodes.input.data('lang');
        const data = {
            limit: 6,
            source: self.suggestionEngine(),
            displayKey: 'title',
            templates: {
                suggestion(res) {
                    // console.log(res)
                    return self.suggestionTemplate(res);
                }, 
                footer(res) {                                    
                    return `<div class="search_response_all">
                                <a href="/${lang}/search?query=${res.query}">${CONFIG_SEARCH.trans.catall}</a>
                            </div>`;
                },
                notFound() {
                    return `<div class="header__middle__search__not-found" style="padding-left: 10px">${CONFIG_SEARCH.trans.notfound}</div><style>.right-part{display:none !important}</style>`;
                }
            }
        };       

        self.nodes.input.typeahead(options, data).on('change blur', () => {})
        .on('blur', () => {            
            self.nodes.body.removeClass("overlay-effect");
            $('html, body').css({ 'position': 'inherit', 'width': '100%' });
            setTimeout( () => {
                self.nodes.form.removeClass('focused');
            } , 100);
        }).on('typeahead:open', () => {                              
            !$('.header').hasClass('clean') ? self.nodes.body.addClass("overlay-effect") : '';           
            self.nodes.form.css('z-index', '100');
            self.nodes.form.addClass('focused');
            $('html, body').css({ 'position': 'fixed', 'width': '100%' });
        }).on('typeahead:selected', function() {
           self.nodes.input.val('');
        }).on('typeahead:asyncrequest', function() {
            self.nodes.form.addClass('busy');
        })
        .on('typeahead:asynccancel typeahead:asyncreceive', function() {
            self.nodes.form.removeClass('busy');
        });
    }

    suggestionTemplate(product) {      
        let current_price = product.price;
        console.log('demo', product.title)
        const html = `<div class="left_part container">
                        <a href="${product.url}" data-id="${product.id}">
                            <span class="wrap-image-search">
                                <img src="${product.img}" alt="">
                            </span>
                            <span class="wrap-title-price-description">
                                <span class="wrapper_left_test">
                                    <span class="wrap-search-title">${this.replaceHtmlEntities(product.title)}</span>
                                    <span class="price-search">
                                        <span class="price-search-fix">${current_price}</span> 									
                                        <span class="grey-lei">${ this.nodes.form.data('currency') }
                                        </span>
                                    </span>
                                </span>
                            </span>
                        </a>
                     </div>`;
        return html;
    }

    validateQuery(query) {
        // Regular expression to match disallowed patterns
        const disallowedPattern = /<|>|&|"/g;
        // Check if the query matches the disallowed pattern
        if (disallowedPattern.test(query)) {
            console.log('Invalid query detected');
            return false;
        }
        return true;
    }

    replaceHtmlEntities(text) {
        if (typeof DOMParser !== 'undefined') {
            // Replace <, >, &, and " with their respective HTML entities
            text = text.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;').replace(/"/g, '&quot;');
            return new DOMParser().parseFromString(text, "text/html").documentElement.textContent;
        } else {
            return this.virtualDiv.html(text).text();
        }
    }

    suggestionEngine() {
        const self = this;
        const lang = self.nodes.input.data('lang');

        return new Bloodhound({
            datumTokenizer: Bloodhound.tokenizers.whitespace,
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            name: 'products',
            remote: {
                url: `${self.nodes.form.data('suggestions')}?query=%QUERY`,
                // Use the validateQuery function
                prepare(query, settings) {
                    query = self.replaceHtmlEntities(query); // Replace HTML entities
                    if (self.validateQuery(query)) {
                        return settings.url.replace('%QUERY', encodeURIComponent(query));
                    } else {
                        return false;
                    }
                },
                wildcard: '%QUERY',
                filter(response) {
                    let listCat = [];
                    const res = {
                        products:[],
                        categories:[],
                    };
                    $.each(response.products, (i, product) => {
                        res.products.push({
                            img: product.image,
                            title: self.replaceHtmlEntities(product.title), // Replace HTML entities
                            price: product.price.value,
                            currency: product.price.unit,
                            id: product._id,
                            url: `/${lang}/${product._id}`
                        });
                    });

                    if (response.in_subcategories) {
                        $.each(response.in_subcategories.slice(0, 8), (i, cat) => {
                            listCat += `<li><a href="${cat.url}"><span class="title">${self.replaceHtmlEntities(cat.title)}</span><span class="counter">${cat.count}</span> </a></li>`;
                        });
                    }
                    const clRightPartList = self.nodes.document.find('.tt-menu').find('.js-right-part');
                    if (clRightPartList.length) {
                        clRightPartList.html(`
                                <p class="right-part-title">
                                    ${CONFIG_SEARCH.trans.search} 
                                    <strong> ${self.replaceHtmlEntities( self.nodes.input.val() )}</strong> 
                                    ${CONFIG_SEARCH.trans.cat}:
                                </p>
                                <ul class="right-part-list">${listCat}</ul>`);
                    } else {
                        const htmlCat = `<div class="js-right-part right-part">
                                            <p class="right-part-title">${CONFIG_SEARCH.trans.search} <strong> ${self.replaceHtmlEntities( self.nodes.input.val() )}</strong> ${CONFIG_SEARCH.trans.cat}:</p>
                                            <ul class="right-part-list">${listCat}</ul>
                                        </div>`;
                        self.nodes.document.find('.tt-menu').append(htmlCat);
                    }
                
                    return res.products;
                },
            }
        });
    }

}

new SearchAutocomplete();
